import 'dayjs/locale/id';
import React from 'react';
import styles from './styles.scoped.css';
import Select from '../../fields/SelectBox/Select';
import IconUpDownArrow from '../../icons/IconUpDownArrow';
import MultipleSelect from '../../fields/MultipleSelect/MultipleSelect';
import { handleValueSelected } from '../../../utils/builder/common';

export const initialValues = {
  regional: '',
  provinceId: '',
  cityId: '',
  districtId: '',
  villageId: '',
  status: ''
};

export const Fields = ({
  values = initialValues,
  handleChangeValues,
  handleSearchFilter,
  // handleChangeValuesDate,
  dropdownData,
  regionalId,
  // provinceId,
  // cityId,
  // cities,
  // minDate
}) => {
  return [
    {
      label: 'Regional',
      disabled: regionalId ? true : false,
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.regional}
          disabled={regionalId ? true : false}
          eventName="regional"
          hideLabel
          name="regional"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'regional', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          overflow={'unset'}
          placeholder="Semua Regional"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={handleValueSelected(values.regional, regionalId)}        />
      ),
    },
    {
      label: 'Provinsi',
      // disabled: provinceId !== '',
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.provinces}
          eventName="provinces"
          hideLabel
          name="provinceId"
          onChange={(value) =>{
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'provinceId', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          overflow={'unset'}
          placeholder="Semua Provinsi"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.provinceId}
        />
      ),
    },
    {
      label: 'Kota/Kab',
      // disabled: JSON.stringify(cities)?.length === 40,
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.cities}
          debounce={true}
          eventName="cities"
          hideLabel
          name="cityId"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'cityId', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          onSearchChange={handleSearchFilter}
          overflow={'unset'}
          placeholder="Semua Kota/Kab"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.cityId}
        />
      ),
    },
    {
      label: 'Kecamatan',
      // disabled: values.cityId?.length === 2 || values.cityId?.length === 0,
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.districts}
          debounce={true}
          eventName="districts"
          hideLabel
          name="districtId"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'districtId', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          onSearchChange={handleSearchFilter}
          overflow={'unset'}
          placeholder="Semua Kecamatan"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.districtId}
        />
      ),
    },
    {
      label: 'Kelurahan' ,
      // disabled: values.districtId === undefined,
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.villages}
          debounce={true}
          eventName="villages"
          hideLabel
          name="villageId"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '');
            handleChangeValues({ name: 'villageId', value: isSelectedAll > -1 || value.length === 0 ? '' : value });
          }
          }
          onSearchChange={handleSearchFilter}
          overflow={'unset'}
          placeholder="Semua Kelurahan"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.villageId}
        />
      ),
    },
    {
      label: 'Status',
      // disabled: !values.districtId,
      component: (
        <Select
          className={styles.cusField}
          data={dropdownData.status}
          eventName="status"
          hideLabel
          name="status"
          onChangeSelect={(value) =>
            handleChangeValues({ name: 'status', value })
          }
          placeholder="Pilih Status"
          rightSection={<IconUpDownArrow />}
          valueForm={values.status}
        />
      ),
    },
  ];
};
